import { createSelector } from 'reselect'
import * as R from 'ramda'
import * as RE from 'helpers/ramda-ext'
import { queryFromString } from 'helpers/url'
import { DEFAULT_PARTNER } from 'constants/partner'
import { DEFAULT_CULTURE, DEFAULT_COUNTRY, DEFAULT_LOCALE } from 'constants/locale'
import { getOpeCodeInPathname } from 'helpers/PathHelper'
import {
  isCatalogOrUniversePagePath,
  isPackagesPagePath,
  isProductPagePath,
  isSaleHomePagePath,
  isSelectionPagePath
} from 'domain/router'
import {
  GetDepartureCitiesFilterFromQuery,
  GetDepartureDatesFilterFromQuery,
  GetDurationsFilterFromQuery,
  GetFrom,
  GetIsCatalogOrUniversePagePath,
  GetIsPackagesPagePath,
  GetIsProductPagePath,
  GetIsSaleHomePagePath,
  GetIsSelectionPagePath,
  GetLocation,
  GetOperationCodeFromUri,
  GetQuery,
  GetQueryKeyParam,
  GetQueryString,
  GetResourceKey,
  GetUri,
  GetURICountryCode,
  GetURICultureCode,
  GetURILocale,
  GetURIPartner
} from './router.types'

export const getLocation: GetLocation = R.path(['router', 'location'])

export const getUri: GetUri = createSelector(
  getLocation,
  R.prop('pathname')
)

export const getOperationCodeFromUri: GetOperationCodeFromUri = createSelector(
  getUri,
  getOpeCodeInPathname
)

export const getQueryString: GetQueryString = createSelector(
  getLocation,
  R.prop('search')
)
// ex: "?saleKey=255_rzd1"
export const getQuery: GetQuery = createSelector(
  getQueryString,
  queryFromString
)

export const getQueryKeyParam: GetQueryKeyParam = createSelector(
  getQuery,
  R.prop('key')
)

export const getDepartureCitiesFilterFromQuery: GetDepartureCitiesFilterFromQuery = createSelector(
  getQuery,
  R.pipe(
    R.prop('departureCities'),
    R.when(RE.isNotEmptyOrNil, R.split(',')),
    R.defaultTo([])
  )
)

export const getDurationsFilterFromQuery: GetDurationsFilterFromQuery = createSelector(
  getQuery,
  R.pipe(
    R.prop('durations'),
    R.when(RE.isNotEmptyOrNil, R.split(',')),
    R.defaultTo([])
  )
)

export const getDepartureDatesFilterFromQuery: GetDepartureDatesFilterFromQuery = createSelector(
  getQuery,
  R.pipe(
    R.prop('departureDates'),
    R.when(RE.isNotEmptyOrNil, R.split(',')),
    R.defaultTo([])
  )
)

export const getFrom: GetFrom = createSelector(
  getQuery,
  R.prop('from')
)

export const getResourceKey: GetResourceKey = createSelector(
  getQuery,
  R.prop('key')
)

export const getURILocale: GetURILocale = createSelector(
  getQuery,
  R.pipe(
    R.prop('lc'),
    R.defaultTo(DEFAULT_LOCALE)
  )
)

export const getURICultureCode: GetURICultureCode = createSelector(
  getURILocale,
  R.pipe(
    R.split('-'),
    R.head,
    R.defaultTo(DEFAULT_CULTURE),
    R.toLower
  )
)

export const getURICountryCode: GetURICountryCode = createSelector(
  getURILocale,
  R.pipe(
    R.split('-'),
    R.last,
    R.defaultTo(DEFAULT_COUNTRY),
    R.toUpper
  )
)

export const getURIPartner: GetURIPartner = createSelector(
  getQuery,
  R.pipe(
    R.prop('partner'),
    R.defaultTo(DEFAULT_PARTNER)
  )
)

export const getIsPackagesPagePath: GetIsPackagesPagePath = createSelector(
  getUri,
  isPackagesPagePath
)

export const getIsSelectionPagePath: GetIsSelectionPagePath = createSelector(
  getUri,
  isSelectionPagePath
)

export const getIsProductPagePath: GetIsProductPagePath = createSelector(
  getUri,
  isProductPagePath
)

export const getIsCatalogOrUniversePagePath: GetIsCatalogOrUniversePagePath = createSelector(
  getUri,
  isCatalogOrUniversePagePath
)

export const getIsSaleHomePagePath: GetIsSaleHomePagePath = createSelector(
  getUri,
  isSaleHomePagePath
)
